import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import * as z from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {AssetItemSchema} from './assetItem'
import {IconLinkItemSchema} from './iconLinkItem'
import {ImageLinkItemSchema} from './imageLinkItem'

export const HeroVariantEnum = z.enum(['Stacked', 'Carousel', 'Icon Cards', 'Image Cards'])
export type HeroVariant = z.infer<typeof HeroVariantEnum>

export const TemplateFlexSuiteOverviewSchema = buildEntrySchemaFor('templateFlexSuiteOverview', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      // Hero
      heroHeading: RichTextSchema,
      heroLabel: z.string().optional(),
      heroDescription: RichTextSchema.optional(),
      heroCtaOne: LinkSchema,
      heroCtaTwo: LinkSchema.optional(),
      heroTertiaryDescription: RichTextSchema.optional(),
      // Variant fields
      heroVariant: HeroVariantEnum.optional(),
      heroImage: AssetSchema.optional(),
      heroCarousel: z.array(AssetItemSchema).optional(),
      heroIconCards: z.array(IconLinkItemSchema).optional(),
      heroImageCards: z.array(ImageLinkItemSchema).optional(),
    }),
  ),
})

export type TemplateFlexSuiteOverview = z.infer<typeof TemplateFlexSuiteOverviewSchema>
